<template>
  <div class="login">
    <div class="login-main">
      <!-- <el-image src="./login-bg.png" class="login-bg" fit="fill">
        <div slot="placeholder" class="image-slot">
          <div class="image-loading"></div>
        </div>
      </el-image>-->
      <div class="login-left"></div>
      <div class="login-right">
        <el-form status-icon :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
          <div class="login-type">
            <div class="login-tip" v-show="loginPc">{{$t('login.wechat')}}</div>
            <div @click="loginPc=!loginPc">
            <svg-icon :iconClass="loginPc?'code':'pc'" class="login-code"></svg-icon></div>
          </div>
          <div class="title">
            <el-image src="./logo.png" fit="contain">
              <div slot="placeholder" class="image-slot">
                <div class="image-loading"></div>
              </div>
            </el-image>
            <span class="ver">
              {{version}}
              <!-- (测试环境) -->
            </span>
            <!-- <span class="title-en">Media Score</span>
            <span class="title-line">|</span>
            <span class="title-cn"></span>-->
            <!-- <span class="title-cn">数据平台</span> -->
          </div>
          <div v-show="loginPc">
            <el-form-item prop="account" class="username-input">
              <el-input :placeholder="$t('login.username')" v-model="loginForm.account">
                <el-image slot="prefix" src="./user.png" class="prefix-icon" fit="contain">
                  <div slot="placeholder" class="image-slot">
                    <div class="image-loading"></div>
                  </div>
                </el-image>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" class="password-input">
              <el-input
                type="password"
                :placeholder="$t('login.password')"
                @change="passwordChange"
                @keyup.enter.native="handleLogin"
                v-model="loginForm.password"
              >
                <el-image slot="prefix" src="./password.png" class="prefix-icon" fit="contain">
                  <div slot="placeholder" class="image-slot">
                    <div class="image-loading"></div>
                  </div>
                </el-image>
              </el-input>
            </el-form-item>

            <div class="remember-me">
              <el-checkbox v-model="rememberMe">{{$t('login.remember')}}</el-checkbox>
            </div>
            <el-button
              class="submit"
              type="primary"
              :loading="loading"
              @click="handleLogin"
            >{{$t('login.signin')}}</el-button>
          </div>
          <div v-show="!loginPc" class="wechat-login">
            <!-- <Empty v-if="modalLoading" :loading="modalLoading"></Empty> -->
            <div class="wechat-code" id="qrcode" ref="qrcode" v-loading="modalLoading"  :element-loading-text="$t('login.loading')">
              <!-- <img src="../../../public/code.png" alt /> -->
            </div>
            <div class="wechat-tip">{{$t('login.wechat')}}</div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import md5 from "js-md5";
import { qrcode } from "@/utils/common";
import { getWxLoginUrl } from "@/api/login";
import Empty from "@/components/Empty";
import { getToken } from "@/utils/auth"; // getToken from cookie
export default {
  components: { Empty },
  data() {
    return {
      modalLoading: false,
      loading: false,
      rememberMe: false,
      originPsw: null,
      hasMd5: false, // 密码是否是从本地读取出来的
      loginForm: {
        account: "",
        password: "",
      },
      rules: {
        password: [{ required: true, message: " ", trigger: "blur" }],
        account: [{ required: true, message: " ", trigger: "blur" }],
      },
      redirect: "/",
      version: this.$store.state.app.version,
      loginPc: true,
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.originPsw = this.loginForm.password; // 登录错误时回复原密码
          this.loginForm.password = this.hasMd5
            ? this.loginForm.password
            : md5(this.loginForm.password.trim());
          this.$store
            .dispatch("LoginByUsername", this.loginForm)
            .then((res) => {
              this.loading = false;
              this.rememberMe ? this.rememberPwd() : this.removePwd();
              this.$router.push({ path: this.redirect });
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err.data);
              this.hasMd5 = true;
            });
        } else {
          return false;
        }
      });
    },
    getLocalRecord() {
      if (window.localStorage.getItem(md5("mh_password"))) {
        this.loginForm.account = window.localStorage.getItem(
          md5("mh_username")
        );
        this.loginForm.password = window.localStorage.getItem(
          md5("mh_password")
        );
        this.hasMd5 = true;
        this.rememberMe = true;
      }
    },
    rememberPwd() {
      window.localStorage.setItem(md5("mh_username"), this.loginForm.account);
      window.localStorage.setItem(md5("mh_password"), this.loginForm.password);
    },
    removePwd() {
      window.localStorage.removeItem(md5("mh_username"));
      window.localStorage.removeItem(md5("mh_password"));
    },
    passwordChange() {
      this.hasMd5 = false;
    },
    // 微信扫码登录（1分钟失效）
    wxLoginByCode() {
      this.modalLoading = true;
      // 获取二维码链接
      getWxLoginUrl().then((res) => {
        const { uuid, webUrl } = res.data;
        this.modalLoading = false;
        this.$nextTick(() => {
          qrcode("qrcode", this.$refs["qrcode"], webUrl);
        });
        // 微信扫码登录
        this.$store
          .dispatch("LoginByCode", uuid)
          .then((res) => {
            this.$router.push({ path: this.redirect });
          })
          .catch((err) => {
            // 超时或者失败重新请求二维码
            if(!getToken()){
            this.wxLoginByCode();
            }
          });
      });
    },
  },
  mounted() {
    this.getLocalRecord();
    console.log("version:", this.$store.state.app.version);
    this.wxLoginByCode();
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../styles/variables.scss";
.login {
  font-size: 1vh;
  height: 100%;
  background: #000000;
  /*background: linear-gradient(#f27189, #fcc39a);*/
  display: flex;
  align-items: center;
  justify-content: center;
  .login-bg {
    width: 100%;
  }
  ::v-deep .login-main {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #ffffff;
    box-shadow: 17px 30px 65px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    z-index: 3;
    background: url(../../../public/login-bg.png);
    background-color: #fff;
    // background-size: 100% auto;
    background-repeat: no-repeat;
    background-size: cover;
    .login-right {
      display: block;
      width: 100%;
      .login-form {
        position: relative;
        width: 420px;
        // width: 28.515625%;
        // min-width: 370px;
        // max-width: 470px;
        padding: 40px 30px;
        float: right;
        margin: 12.96875% 7.6% 0 0;
        background-color: #fff;
        box-shadow: 0 0 10px #eee;
        height: 440px;
        .el-input__prefix {
          line-height: 50px;
        }
        .login-type {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          position: absolute;
          right: 0;
          top: 0;
          user-select: none;
          // svg{
          //   display: inline-block;
          //   width: 42px;
          //   height: 64px;
          // }
        }
        .login-tip {
          position: relative;
          background-color: #eee;
          padding: 5px 10px;
          border-radius: 5px;
          color: $primary;
          margin-top: 10px;
        }
        .login-tip:after {
          content: "";
          position: absolute;
          left: 100%;
          bottom: -30px;
          width: 0;
          height: 0;
          border-width: 6px;
          border-style: solid;
          border-color: transparent;
          margin-bottom: 36px;
          border-left-width: 6px;
          border-left-color: currentColor;
          color: #eee;
        }
        // .login-wechat {
        //   background: url("../../../public/pc.png") 30px 0 no-repeat;
        //   background-size: 42px 64px;
        // }
        // .login-pc {
        //   background: url("../../../public/code.png") 0 0 no-repeat;
        //   background-size: cover;
        // }
        .login-code {
          color: $primary;
          display: inline-block;
          cursor: pointer;
          width: 75px;
          height: 70px;
          clip-path: polygon(100vw 0, 0% 0vh, 1000px 100vh);
        }
        .wechat-login {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .wechat-code {
              width: 200px;
              height: 200px;
            img {
              width: 200px;
              height: 200px;
            }
          }
          .wechat-tip {
            font-size: 14px;
          }
        }
      }
    }
    .login-form {
      .title {
        margin-bottom: 30px;
        .el-image {
          width: 143px;
          margin-right: 5px;
        }
        .el-image,
        span {
          display: inline-block;
          // vertical-align: middle;
          // line-height: 1;
        }
        span {
          // font-weight: 600;
          // font-size: 14px;
          color: #44444f;
        }
        .title-en {
          font-size: 16px;
          margin-right: 10px;
        }
        .title-line {
          width: 0px;
          height: 20px;
          font-weight: normal;
          margin: 0 9px 0 11px;
          border-radius: 1px;
          background: #44444f;
          overflow: hidden;
        }
        .title-cn {
          font-size: 22px;
        }
      }
      .el-form-item {
        margin-bottom: 27px;
        border-radius: 4px;
        border: 1px solid #e2e2ea;
        .prefix-icon {
          height: 16px;
          vertical-align: middle;
        }
        .label {
          font-size: 18px;
          font-weight: 400;
          color: rgba(162, 162, 162, 1);
          line-height: 25px;
        }
        .el-input__inner {
          border: none;
          /* font-size: 16px; */
        }
        .el-input--prefix .el-input__inner {
          height: 53px;
          line-height: 53px;
          padding-left: 37px;
          padding-right: 35px;
        }
      }
      .remember-me {
        margin-top: 30px;
        // .el-checkbox__input {
        //   line-height: 19px;
        // }
        .el-checkbox__label {
          font-size: 14px;
          color: #92929d;
        }
      }
      .submit {
        width: 100%;
        font-size: 16px;
        border-radius: 4px;
        height: 53px;
        padding: 0;
        margin-top: 60px;
      }
    }
  }
}
</style>
<style lang="scss">
.login-form {
  input {
    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px #fff inset !important;
      -webkit-text-fill-color: #333 !important;
    }
  }
}
</style>
